import { useContext, useEffect, useState } from 'react'
import { useParams, withRouter } from 'react-router-dom'
import * as H from 'history'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { Alert, Button, ButtonGroup, ToggleButton } from 'react-bootstrap'
import { GlobalStateContext } from 'contexts/global_state_context'
import { Flex } from 'components/shared/flex'
import { A4, Landscape, Portrait } from 'components/shared/print'
import { RequestForm, RequestFormSearchForm } from 'entities/request_form'
import template from 'components/../../public/qr_request_sheet.jpg'
import { RequestFormPrintForm, useFetchRequestFormsApi } from 'api/request_form'
import './preview.scss'
import { usePrintRequestFormIssuanceApi } from 'api/request_form_issuance'
import { PROBE_COLORS } from 'entities/pcr_run'
import { setPageSize } from 'utils/util'
import QRCode from 'qrcode.react'
import _, { unset } from 'lodash'
import styled from 'styled-components'

type Props = {
    history: H.History
}

const VerticalText = styled.div`
    transform: rotate(-90deg);
    letter-spacing: 0.2em;
`

const PreviewRequestForm = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const { id } = useParams<{ id: string }>()
    const params = useQuery<RequestFormSearchForm & { institutionName: string; institutionCode: string; shippingCode: string }>()
    const searchForm = useForm<RequestFormSearchForm>({ ...params, perPage: 10000 })
    const api = useFetchRequestFormsApi(searchForm)
    const printForm = useForm<RequestFormPrintForm>({ ids: params.id }) // このidは配列
    const printApi = usePrintRequestFormIssuanceApi()
    const [currentState, setCurrentState] = useState<'request_form' | 'barcode'>('request_form')

    const handleAfterPrint = () => {
        if (currentState === 'request_form') {
            setCurrentState('barcode')
            globalState.showConfirm(<>バーコードシール用紙(品番：OP3306)をプリンタにセットし、印刷プレビューをクリックしてください</>)
        } else {
            globalState.showConfirm(
                <>
                    印刷完了しましたか？
                    <br />
                    OKを押すと印刷済みステータスへ移行します
                </>,
                () => {
                    printApi.execute(Number(id), printForm)
                },
                {
                    backdropStatic: true,
                    onCancel: () => {
                        setCurrentState('request_form')
                    },
                }
            )
        }
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
    }, [api.loading])

    useEffect(() => {
        setPageSize('portrait')
        api.execute()
    }, [])
    let count = 0

    return (
        <div className="preview-request-form">
            <Flex className="no-print" style={{ marginLeft: 20 }} alignItems="center">
                <div style={{ padding: 15 }}>
                    <Button
                        style={{ width: 200 }}
                        onClick={() => {
                            window.print()
                            handleAfterPrint()
                        }}
                    >
                        印刷プレビュー
                    </Button>
                </div>

                <ButtonGroup>
                    <ToggleButton
                        id={`radio-request-form`}
                        type="radio"
                        variant={'outline-secondary'}
                        name="radio"
                        value={'request_form'}
                        checked={currentState === 'request_form'}
                        onChange={(e) => setCurrentState('request_form')}
                    >
                        依頼書
                    </ToggleButton>
                    <ToggleButton
                        id={`radio-rack`}
                        type="radio"
                        variant={'outline-secondary'}
                        name="radio"
                        value={'barcode'}
                        checked={currentState === 'barcode'}
                        onChange={(e) => setCurrentState('barcode')}
                    >
                        バーコードシート
                    </ToggleButton>
                </ButtonGroup>
            </Flex>
            {currentState === 'request_form' && (
                <div>
                    <Portrait>
                        {api.response.results.map((requestForm: RequestForm, index: number) => {
                            return (
                                <>
                                    <A4 padding={0} landscape={false}>
                                        <div className="page-root" style={{ width: '100%', height: '100%', position: 'relative' }}>
                                            <img src={template} style={{ objectFit: 'contain', width: '209mm' }} />
                                            <div style={{ fontSize: 24, fontWeight: 'bold', position: 'absolute', left: 20, top: 20, color: '#333' }}>
                                                {params.institutionName}
                                            </div>
                                            <div style={{ fontSize: 12, position: 'absolute', right: 30, top: 290 }}>{requestForm.code}</div>
                                            <div style={{ fontSize: 12, position: 'absolute', right: 160, top: 290 }}>
                                                <div style={{ width: 20, height: 20, borderRadius: 20, border: '1px solid #333', textAlign: 'center' }}>
                                                    {index + 1}
                                                </div>
                                            </div>
                                            {/* <div style={{ fontSize: 12, position: 'absolute', right: 30, top: 20 }}>{params.shippingCode}</div> */}
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    right: 115,
                                                    margin: 'auto',
                                                    top: 415,
                                                    textAlign: 'center',
                                                }}
                                            >
                                                <div style={{ backgroundColor: 'white', height: 102, width: 102 }}>
                                                    <QRCode
                                                        size={102}
                                                        style={{
                                                            borderRadius: 3,
                                                            border: `4px solid ${PROBE_COLORS[(index + 1) % PROBE_COLORS.length]}`,
                                                            padding: 10,
                                                        }}
                                                        value={`${process.env.REACT_APP_INTERVIEW_SHEET_URL}?tubeId=${requestForm.code}`}
                                                    />
                                                </div>
                                                <div style={{ marginTop: -4, fontSize: 12 }}>{requestForm.code}</div>
                                            </div>
                                        </div>
                                    </A4>
                                    {/* {[douisho].map((file, index) => {
                                        return (
                                            <A4 padding={0} landscape={false} key={'file' + index}>
                                                <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                                                    <img src={file} style={{ objectFit: 'contain', width: '209mm' }} />
                                                </div>
                                            </A4>
                                        )
                                    })} */}
                                </>
                            )
                        })}
                    </Portrait>
                </div>
            )}
            {currentState === 'barcode' && (
                <>
                    <div className="no-print">
                        <Alert variant="info">バーコードシール用紙をプリンタにセットしてください</Alert>
                    </div>
                    {_.chunk(api.response.results, 21).map((pageItems, pageIndex) => {
                        return (
                            <Landscape key={'page' + pageIndex}>
                                <A4 padding={0} landscape={false} style={{ position: 'relative' }}>
                                    <div
                                        style={{
                                            position: 'absolute',
                                            zIndex: 100,
                                            bottom: 0,
                                            right: 0,
                                        }}
                                    >
                                        <div
                                            style={{
                                                padding: 15,
                                                fontSize: 12,
                                            }}
                                        >
                                            {params.institutionName} - {params.institutionCode} ({params.shippingCode})
                                        </div>
                                    </div>
                                    <div>
                                        {(() => {
                                            return _.chunk(pageItems, 3).map((requestForms: RequestForm[], index: number) => {
                                                return (
                                                    <Flex className="" key={'form-chunk-' + index}>
                                                        {new Array(3).fill(0).map((_, index) => {
                                                            count += 1
                                                            const requestForm = requestForms[index]
                                                            return (
                                                                <div
                                                                    style={{
                                                                        position: 'relative',
                                                                        flexGrow: 1,
                                                                        height: '42.3mm',
                                                                        padding: '9.5mm 10mm',
                                                                    }}
                                                                    key={requestForm?.code}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            fontSize: 11,
                                                                            width: '50mm',
                                                                            height: '100%',
                                                                            padding: 5,
                                                                            border: '1px dashed #888',
                                                                            position: 'relative',
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                position: 'absolute',
                                                                                fontSize: 10,
                                                                                transform: 'scale(0.7) rotate(-90deg)',
                                                                                left: -65,
                                                                                bottom: 36,
                                                                            }}
                                                                        >
                                                                            ↓点線で剥がしてください
                                                                        </div>
                                                                        {requestForm && (
                                                                            <div style={{ flexGrow: 1, width: '100%' }}>
                                                                                <Flex style={{ width: '100%' }}>
                                                                                    <div style={{ flexGrow: 1 }}>
                                                                                        <div
                                                                                            style={{
                                                                                                display: 'flex',
                                                                                                position: 'absolute',
                                                                                                top: 1,
                                                                                            }}
                                                                                        >
                                                                                            <VerticalText>氏</VerticalText>
                                                                                            <VerticalText>名</VerticalText>
                                                                                            <div style={{ marginTop: 3 }}>（</div>
                                                                                            <VerticalText>カ</VerticalText>
                                                                                            <VerticalText>タ</VerticalText>
                                                                                            <VerticalText>カ</VerticalText>
                                                                                            <VerticalText>ナ</VerticalText>
                                                                                            <div style={{ marginTop: 3 }}>）</div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        style={{
                                                                                            position: 'relative',
                                                                                            marginRight: 5,
                                                                                            transform: 'rotate(-90deg)',
                                                                                        }}
                                                                                    >
                                                                                        <div
                                                                                            style={{
                                                                                                marginRight: 2,
                                                                                                right: -5,
                                                                                                position: 'absolute',
                                                                                                bottom: 55,
                                                                                                transform: 'scale(0.7)',
                                                                                            }}
                                                                                        >{`(${requestForm?.institution?.id})`}</div>
                                                                                        <QRCode
                                                                                            value={requestForm.code!}
                                                                                            size={50}
                                                                                            style={{
                                                                                                padding: 2,
                                                                                                border: `3px solid ${
                                                                                                    PROBE_COLORS[count % PROBE_COLORS.length]
                                                                                                }`,
                                                                                            }}
                                                                                        />
                                                                                        <Flex>
                                                                                            <div
                                                                                                style={{
                                                                                                    position: 'absolute',
                                                                                                    bottom: -8,
                                                                                                    textAlign: 'center',
                                                                                                    width: '100%',
                                                                                                    transform: 'scale(0.8)',
                                                                                                }}
                                                                                            >
                                                                                                {requestForm.code!}
                                                                                            </div>
                                                                                        </Flex>
                                                                                    </div>
                                                                                </Flex>
                                                                                <Flex style={{ padding: '5px 0' }}>
                                                                                    <div style={{ flexGrow: 1 }}>
                                                                                        <div
                                                                                            style={{
                                                                                                transform: 'rotate(-90deg)',
                                                                                                width: 1,
                                                                                                transformOrigin: 'top',
                                                                                                marginTop: 15,
                                                                                            }}
                                                                                        >
                                                                                            年齢
                                                                                        </div>
                                                                                    </div>
                                                                                    <Flex style={{ marginRight: 5 }} justifyContent="flex-end">
                                                                                        <div style={{ transform: 'rotate(-90deg)' }}>男</div>
                                                                                        <div>・</div>
                                                                                        <div style={{ transform: 'rotate(-90deg)' }}>女</div>
                                                                                    </Flex>
                                                                                    <div>
                                                                                        <div
                                                                                            style={{
                                                                                                borderRadius: 10,
                                                                                                border: 'solid 1px #333',
                                                                                                width: 14,
                                                                                                height: 14,
                                                                                                lineHeight: 1.1,
                                                                                                textAlign: 'center',
                                                                                                transform: 'rotate(-90deg) ',
                                                                                                marginLeft: 5,
                                                                                                marginTop: 3,
                                                                                            }}
                                                                                        >
                                                                                            {count}
                                                                                        </div>
                                                                                    </div>
                                                                                </Flex>
                                                                                {/* <div style={{ transform: 'scale(0.75)', width: '21mm', textAlign: 'right', marginTop: 8 }}>
                                                                                <div>{requestForm?.institution?.code}</div>
                                                                            </div> */}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </Flex>
                                                )
                                            })
                                        })()}
                                    </div>
                                </A4>
                            </Landscape>
                        )
                    })}
                </>
            )}
        </div>
    )
}

export default withRouter(PreviewRequestForm)
